import NavIcon from './NavIcon';

function NavLink({ item, isActive }) {
  return (
    <a
      className={isActive ? 'nav-button is-active' : 'nav-button'}
      href={item.path}
      aria-current={isActive ? 'page' : undefined}
    >
      <NavIcon name={item.icon} />
      <span>{item.label}</span>
      {item.authRequired ? <span className="nav-lock" aria-label="로그인 필요" /> : null}
    </a>
  );
}

export default NavLink;
